export default __webpack_public_path__ + "static/media/call-center-01.12996ff6.jpg";